// extracted by mini-css-extract-plugin
export default {"payment":"Payment_payment__XJmBk","cart":"Payment_cart__L0EMo","thanhtoan":"Payment_thanhtoan__TILJ4"};